import script from "./FrontView.vue?vue&type=script&setup=true&lang=js"
export * from "./FrontView.vue?vue&type=script&setup=true&lang=js"

import "./FrontView.vue?vue&type=style&index=0&id=2e3c9d37&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e3c9d37"]])

export default __exports__